// extracted by mini-css-extract-plugin
module.exports = {"Step1":"Step1_Step1__3DS8z","LabelTypography":"Step1_LabelTypography__9OQ9q"};